import { render, staticRenderFns } from "./naturaleza.vue?vue&type=template&id=c3df65ee&"
import script from "./naturaleza.vue?vue&type=script&lang=js&"
export * from "./naturaleza.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports